import { createIntl, enUSIntl, ruRUIntl, type IntlType } from '@ant-design/pro-provider';
import tjTJProLocaleMap from './tj-TJ';

const tjTJIntl = createIntl('tg_TJ', tjTJProLocaleMap);

/** ProComponents intl: tj-TJ has no built-in pack and otherwise falls back to zh-CN (展开). */
export function getProIntl(locale: string): IntlType {
  if (locale === 'en-US') return enUSIntl;
  if (locale === 'tj-TJ') return tjTJIntl;
  return ruRUIntl;
}
